import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../Assets/logo.svg";
import Vectorlogout from "../../Assets/Vectorlogout.png";
import Vector from "../../Assets/Vector.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/api";
import { useToast } from "../../mesageToast/ToastContainer";
import { disconnectSupportSocket } from "../../hooks/useSupportWebSocket";
// import { useDispatch } from "react-redux";
// import { logout } from "../../redux/Slice/OrderSlice";
// import api from "../../services/api";
// import { logOutUser } from "../../redux/Slice/authSlice";

const BoSidebar = ({ sseConnectionLogout, closeSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const addToast = useToast();

  useEffect(() => {
    const isDesktop = window.innerWidth <= 1024;
    if (isDesktop) {
      setIsSidebarOpen(true);
    }
  }, []);
  //   const dispatch = useDispatch();

  const handlePageSelect = (page, route) => {
    setActivePage(page);
    navigate(route); // Navigate to the appropriate route
  };
  useEffect(() => {
    // Set the active page based on the current route path
    const path = location.pathname;
    if (path.includes("/BOD/dashboard")) setActivePage("Dashboard");
    else if (path.includes("/BOD/restaurants-approvals"))
      setActivePage("Restaurants_Approvals");
    else if (path.includes("/BOD/payments-management"))
      setActivePage("Payments_Management");
    else if (path.includes("/BOD/reports")) setActivePage("Reports");
    else if (path.includes("/BOD/support-escalations"))
      setActivePage("SupportEscalations");
    else setActivePage(""); // Default state if no matching path
  }, [location]); // Re-run effect whenever location changes

  const handleLogout = async () => {
    disconnectSupportSocket();
    api
      .get("/logout")
      .then((res) => {
        console.log(res);
        localStorage.clear();
        sessionStorage.clear();
        addToast("Logout", "Logout Successfully", "success");
        navigate("/", { replace: true });
      })
      .catch((err) => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/", { replace: true });
        // console.log(err);
      });
    //   try {
    //     const token =
    //       localStorage.getItem("token") || sessionStorage.getItem("token");
    //     if (!token) {
    //       navigate("/", { replace: true });
    //       return;
    //     }
    //     const TokenString = JSON.parse(token);
    //     const name = TokenString.restaurant;
    //     await api.get(`/logout/${name}`);
    //     localStorage.removeItem("token");
    //     sessionStorage.removeItem("token");
    //     sseConnectionLogout();
    //     dispatch(logout()); // Dispatch logout action
    //     dispatch(logOutUser());
    //     navigate("/"); // Redirect to login page
    //   } catch (err) {
    //     console.log(err);
    //   }
  };

  const [logoutImage, setLogoutImage] = useState(Vectorlogout); // State for logout image

  return (
    <div className="sidebar-overlay" onClick={closeSidebar}>
      <div className="sidebar">
        <div className="sidebar-close">
          <FontAwesomeIcon icon={faAnglesLeft} style={{ color: "#ec8e22" }} />
        </div>
        <div className="sidebarlogo">
          <img src={Logo} alt="logo" />
        </div>
        <ul
          className="sidebar-list"
          style={{ color: "#B1B1B1", fontSize: "20px" }}
        >
          <li
            className={activePage === "Dashboard" ? "active" : ""}
            onClick={() => handlePageSelect("Dashboard", "/BOD/dashboard")}
          >
            <div className="sidebar-li">
              {/* <img
              src={orders}
              alt="orders"
              className={activePage === "Orders" ? `selectedImg` : ""}
            /> */}
              Dashboard
            </div>
          </li>

          <li
            className={activePage === "Restaurants_Approvals" ? "active" : ""}
            onClick={() =>
              handlePageSelect(
                "Restaurants_Approvals",
                "/BOD/restaurants-approvals",
              )
            }
          >
            <div className="sidebar-li">
              {/* <img
              src={complaints}
              alt="menu"
              className={activePage === "Restaurants" ? `selectedImg` : ""}
            /> */}
              Restaurants Approvals
            </div>
          </li>

          <li
            className={activePage === "Payments_Management" ? "active" : ""}
            onClick={() =>
              handlePageSelect(
                "Payments_Management",
                "/BOD/payments-management",
              )
            }
          >
            <div className="sidebar-li">
              {/* <img
              src={complaints}
              alt="complaints"
              className={activePage === "Complaints" ? `selectedImg` : ""}
            /> */}
              Payment Management
            </div>
          </li>

          <li
            className={activePage === "Reports" ? "active" : ""}
            onClick={() => handlePageSelect("Reports", "/BOD/reports")}
          >
            <div className="sidebar-li">
              {/* <img
              src={settings}
              alt="settings"
              className={activePage === "Analytics" ? `selectedImg` : ""}
            /> */}
              Reports
            </div>
          </li>

          <li
            className={activePage === "SupportEscalations" ? "active" : ""}
            onClick={() =>
              handlePageSelect("SupportEscalations", "/BOD/support-escalations")
            }
          >
            <div className="sidebar-li">Support Escalations</div>
          </li>

          <li onClick={handleLogout} className="sidebar-logout">
            <div className="sidebar-li">
              <button
                onMouseEnter={() => setLogoutImage(Vector)} // Change image on hover
                onMouseLeave={() => setLogoutImage(Vectorlogout)} // Revert back on leave
              >
                <img
                  src={logoutImage}
                  alt="logout"
                  //className={activePage === "Dashboard" ? `selectedImg` : ""}
                />
                Log Out
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default BoSidebar;
